<template>
  <div class="statuses dbox">
    <div class="dt-list">
      <div class="dt-list-item" 
        v-for="status of selectedArtistData.statuses" 
        :key="status.checklist_id">
        <div class="dt-list-item--body">
          <div class="dt-list-item--text">
            {{status.booking_status_name}}
          </div>
          <div  
            class="dt-list-item--text ut-flex"
          >
            <div class="color-box"
              :style="{
                'background-color': `#${status.booking_status_colour}`
              }"
            >
            </div>
          </div>
        </div>
        <div class="dt-list-item--options ut-flex">
          <div class="dt-checkbox v2 s1">
            <input type="checkbox" 
            :name="status.booking_status_name" 
            :id="status.booking_status_name" 
            :checked="selectedStatuses.has(status.booking_status_id)"
            @click="e => onCheckboxChange(e, status)">
            <div class="checkmark"></div>
          </div>
        </div>
      </div>    
    </div>
  </div>
</template>

<script>
import { ArtistService } from '../../../services/artists';
import { EventHooks } from '../../../../../plugins/text-field';
import { addRemoveSet } from '../../../../../utility';


export default {
  components: {
  },
  props: {
    selectedArtistData: {
      type: Object,
      required: true
    },
    selectedStatuses: {
      type: Set,
      required: true,
    }
  },
  data: function() {
    return {

      // Mark: Data
    };
  },
  mounted: function() {
    
  },
  watch: {

  },
  computed: {
  },
  methods: {
    onCheckboxChange: function(event, status) {
      this.$emit('changed', addRemoveSet(event.target.checked, this.selectedStatuses, status.booking_status_id));
    }
    // Mark: Methods
  },
}

</script>

<style lang="scss" scoped>

  .dt-input-box--container {
    margin: 5px;
  }

  .color-box {
    width: 15px;
    height: 15px;
  }

  .dt-list .dt-list-item--options {
    min-width: 20px;
  }

</style>
